import React, { useState } from 'react';
import './DownloadModal.css';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import { useLanguage } from '../../../contexts/LanguageContext'

function DownloadModal() {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const { translations: tRaw } = useLanguage();
  const t = { downloadModal: {}, ...tRaw, downloadModal: { ...tRaw?.downloadModal } };

  return (
    <>
      <button className='download-btn' onClick={handleOpen}>
        {t?.downloadModal?.downloadButton || "Get The App"}
      </button>

      {isOpen && (
        <div className='modal-overlay' onClick={handleClose}>
          <div className='modal-container' onClick={(e) => e.stopPropagation()}>
            <h2 className='modal-header'>
              {t?.downloadModal?.title || "Get iWinto"}
            </h2>
            <p>
              {/* {t?.downloadModal?.subtitle || "You can Download iWinto for free on both the App Store and the Play Store"} */}
            </p>
            <div className='store-buttons'>
              <a 
                href="https://apps.apple.com/ao/app/iwinto/id6482291656"
                rel="noopener noreferrer"
                className="store-btn apple"
                target="_blank"
              >
                <FaApple size={20} /> {t?.downloadModal?.appStore || "App Store"}
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=com.winto.app"
                className="store-btn google"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGooglePlay size={20} /> {t?.downloadModal?.playStore || "Play Store"}
              </a>
            </div>
            <button className="download-close-btn" onClick={handleClose}>
              {t?.downloadModal?.close || "Close"}
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default DownloadModal;
